import { RouteObject, Navigate } from "react-router-dom"
import { RedirectUriSaveDecorator } from "../components/RoutesDecorator/RedirectUriSaveDecorator"
import { ConfirmMail, ErrorPage } from "../pages"

const commonRoutes : RouteObject[] = [
    {
        path: 'es/authorization',
        element: <RedirectUriSaveDecorator />
    },
    {
        path: 'email_confirm',
        element: <ConfirmMail />
    },
    {
        path: 'error',
        element: <ErrorPage />
    },
    {
        path: '*',
        element: <Navigate to="/" replace />
    } 
]

export default commonRoutes